<template>
  <div class="loading-container" v-if="visible">
    <div class="loading-wrapper">
      <div class="loading-spinner"></div>
      <div class="loading-text">{{ text }}</div>
    </div>
  </div>
</template>

<script>
import i18n from '@/i18n'

export default {
  name: 'LoadingAnimation',
  data() {
    return {
      visible: false,
      text: i18n.t('common.loading')
    }
  },
  methods: {
    show(text) {
      if (text) {
        this.text = text;
      }
      this.visible = true;
    },
    hide() {
      this.visible = false;
    }
  }
}
</script>

<style scoped>
.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.loading-text {
  margin-top: 15px;
  font-size: 16px;
  color: #333;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
